export const SECONDS_PER_MINUTE = 60;
export const BYTES_PER_MB = 1024 * 1024;

export const MAX_RECORDING_SECONDS = 600;
export const MAX_RECORDING_MINUTES = MAX_RECORDING_SECONDS / SECONDS_PER_MINUTE;
export const MAX_UPLOAD_MB = 150;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * BYTES_PER_MB;

export const VIDEO_BITS_PER_SECOND = 1_500_000;
export const AUDIO_BITS_PER_SECOND = 96_000;

export const VIDEO_WIDTH = 1280;
export const VIDEO_HEIGHT = 720;
export const VIDEO_FRAME_RATE = 24;

export const WARNING_SECONDS_REMAINING = 60;

export const SIZE_SAFETY_MARGIN = 0.95;
export const RECORDER_TIMESLICE_MS = 1000;
